import { connectedStore } from '../../store';
import getIntegrationLimits from '../selectors/limits';

const getLimits = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return getIntegrationLimits(state);
};

export default getLimits;
